module.exports = __webpack_public_path__ + "static/media/bussiness2.e9c4a819.png";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/page_websitesec/bussiness2.png
// module id = 773
// module chunks = 0